<template>
  <TolModal
    :title="$t('projects.eventTypes.details.specialRequirements.add')"
    :submit-button-text="$t('projects.details.labels.save')"
    @close="clearFormAndClose"
    @submit="save"
  >
    <template v-slot:body>
      <form>
        <div class="form-group">
          <div class="form-control">
            <label>
              {{ $t('projects.eventTypes.details.specialRequirements.description') }}
              <span class="asterisk">*</span>
            </label>
            <DropdownSelect
              :menu-items="types"
              :selected-item="selectedType"
              class="bordered"
              @select-item="changeSelectedType"
            />
          </div>
          <div class="form-control">
            <label>
              {{ $t('projects.eventTypes.details.specialRequirements.description') }}
              <span class="asterisk">*</span>
            </label>
            <InputField
              v-model="specialRequirement.description"
              type="text"
              class="bordered"
              :class="{ error: formErrors['description'] }"
              picker="minus-circle"
              @input="specialRequirement.description = $event"
              @picker-click="specialRequirement.description = ''"
            />
          </div>
          <div class="form-control">
            <label>
              {{
                selectedType === 'TEXT'
                  ? $t('projects.eventTypes.details.specialRequirements.value')
                  : $t('projects.eventTypes.details.specialRequirements.valueYesNo')
              }}
              <span class="asterisk">*</span>
            </label>
            <InputField
              v-if="selectedType === 'TEXT'"
              v-model="specialRequirement.value"
              type="text"
              class="bordered"
              :class="{ error: formErrors['value'] }"
              picker="minus-circle"
              @input="specialRequirement.value = $event"
              @picker-click="specialRequirement.value = ''"
            />
            <Checkbox
              v-else
              size="tiny"
              :checked="specialRequirement.value"
              @change="specialRequirement.value = !specialRequirement.value"
            />
          </div>
          <div class="form-control">
            <label>
              {{ $t('projects.eventTypes.details.specialRequirements.comments') }}
            </label>
            <TolTextArea
              v-model="specialRequirement.comments"
              class="form-textarea"
              @change="specialRequirement.comments = $event.target.value"
            />
          </div>
        </div>
      </form>
    </template>
  </TolModal>
</template>

<script>
import Checkbox from '@/app/components/Checkbox';
import DropdownSelect from '@/app/components/DropdownSelect';
import InputField from '@/app/components/InputField';
import TolModal from '@/app/components/TolModal';
import TolTextArea from '@/app/components/TolTextArea';

export default {
  name: 'AddSpecialRequirementModal',
  components: {
    Checkbox,
    DropdownSelect,
    InputField,
    TolModal,
    TolTextArea
  },
  data() {
    return {
      specialRequirement: {
        description: '',
        value: null,
        comments: ''
      },
      selectedType: 'TEXT',
      types: ['TEXT', 'CHECKBOX']
    };
  },
  computed: {
    formErrors() {
      return this.$store.getters.ProjectEventTypeSpecialRequirementsValidationErrors;
    }
  },
  methods: {
    changeSelectedType(event) {
      if (event !== this.selectedType) {
        this.specialRequirement.value = null;
      }
      this.selectedType = event;
    },
    clearFormAndClose() {
      this.specialRequirement = {
        description: '',
        value: null,
        comments: ''
      };
      this.selectedType = 'TEXT';
      this.$emit('close');
    },
    async save() {
      const payload = {
        field: 'special_requirements',
        type: 'SPECIAL_REQUIREMENTS',
        value: { requirement: this.specialRequirement }
      };
      this.$emit('save', payload);
    }
  }
};
</script>

<style scoped lang="scss">
.form-group > div {
  margin-bottom: 1rem;
}

.form-textarea {
  min-width: 30rem;
}

.asterisk {
  color: red;
}
</style>
